import { useForm } from 'react-hook-form';

/**
 * Hook personalizado para manejar los formularios del cliente
 * Separa el formulario principal del formulario de soporte técnico
 */
const useClienteForms = () => {
    // Formulario principal del cliente
    const {
        register,
        setValue,
        reset,
        handleSubmit,
        watch,
        formState: { errors }
    } = useForm();

    // Formulario separado para el modal de soporte técnico
    const {
        register: registerSoporte,
        handleSubmit: handleSubmitSoporte,
        reset: resetSoporte,
        formState: { errors: errorsSoporte }
    } = useForm();

    return {
        // Formulario principal
        formPrincipal: {
            register,
            setValue,
            reset,
            handleSubmit,
            watch,
            errors
        },
        
        // Formulario de soporte
        formSoporte: {
            register: registerSoporte,
            handleSubmit: handleSubmitSoporte,
            reset: resetSoporte,
            errors: errorsSoporte
        }
    };
};

export default useClienteForms;
